/**
 * 
 * key
 * 
 */


const key = 'cG9zdENybUNvbG9yQ29ycmVjdGVk'

export default key 